import { Tracker, TrackerTypeWithClientId } from '../../models/Tracker';
import { TrackerSettingExtraFieldConfig } from '~/models/TrackerSettingExtraFields';

export class Snapchat implements TrackerTypeWithClientId {
  id: number = Tracker.TYPE_SNAPCHAT;
  label: string = 'Snapchat Pixel';
  isEnabled: boolean = true;
  hasClientId: boolean = true;
  isRequireClientId = true;

  getClientIdRegexp(): RegExp {
    return /^[0-9a-f]{8}(-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i
  }

  getExtraFields(): TrackerSettingExtraFieldConfig[] {
    return [];
  }
}
